import React from 'react';
import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider, THEME } from '@tonconnect/ui-react';
import App from './App';
import { TONCONNECT_MANIFEST_URL, API_URL } from './config';
import { lang } from './i18n';
import './styles/Game.css';

// Initialize Telegram Mini App when running inside Telegram
async function initTelegram(): Promise<void> {
  try {
    const { init, miniApp, viewport } = await import('@telegram-apps/sdk');
    init();
    if (miniApp.mount.isAvailable()) {
      miniApp.mount();
      miniApp.ready();
      if (miniApp.setHeaderColor.isAvailable()) {
        miniApp.setHeaderColor('#0a0a0a');
      }
      if (miniApp.setBackgroundColor.isAvailable()) {
        miniApp.setBackgroundColor('#0a0a0a');
      }
    }
    if (viewport.mount.isAvailable()) {
      await viewport.mount();
      if (viewport.expand.isAvailable()) viewport.expand();
    }
  } catch {
    // Not running inside Telegram — standalone browser mode
  }
}

initTelegram();

// Report the detected UI language so the bot replies in the same language
// (initData's user.language_code can lag behind on Telegram's side).
function reportLang(): void {
  try {
    const id = (window as unknown as {
      Telegram?: { WebApp?: { initDataUnsafe?: { user?: { id?: number } } } };
    }).Telegram?.WebApp?.initDataUnsafe?.user?.id;
    if (!id) return;
    fetch(`${API_URL}/api/lang`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chat_id: String(id), lang }),
    }).catch(() => { /* best-effort */ });
  } catch { /* not inside Telegram */ }
}

reportLang();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TonConnectUIProvider
      manifestUrl={TONCONNECT_MANIFEST_URL}
      uiPreferences={{ theme: THEME.DARK }}
    >
      <App />
    </TonConnectUIProvider>
  </React.StrictMode>
);
